<template>
  <div class="table-wrapper" ref="tableWrapper">
    <div class="whole_contract_from">
      <el-form ref="from_params" :rules="params_rules" :model="params">
        <QS-search maxLine="1">
          <!-- 内容区域-->
          <el-form-item label="车牌号" prop="carId">
            <el-select
              v-model="params.carId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入"
              :remote-method="
                (e) => {
                  remoteMethod(e, 'carId')
                }
              "
              >
              <el-option
                v-for="item in carOptions"
                :key="'carOptions' + item.id"
                :label="item.plateNo"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="司机姓名" prop="customerId">
            <el-select
              v-model="params.customerId"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入"
              :loading="loading"
              :remote-method="
                (e) => {
                  remoteMethod(e, 'customerId')
                }
              "
              >
              <el-option
                v-for="item in options"
                :key="'options' + item.id"
                :label="item.customerName"
                :value="item.id"
                >
                <CustomerNameOptionItem :data="item" />
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属司管" prop="driverManagerId">
            <el-select
              v-model="params.driverManagerId"
              filterable
              clearable
              placeholder="请选择司管人员"
              :loading="dmLoading"
              >
              <el-option
                v-for="item in dmOptions"
                :key="'dmOptions' + item.id"
                :label="item.userName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID" prop="id">
            <el-input
              v-number:integer
              v-model="params.id"
              placeholder="请输入订单ID"
              clearable
            />
          </el-form-item>
          <el-form-item label="运营城市" prop="adcode">
            <el-select
              v-model="params.adcode"
              clearable
              filterable
              reserveKeyword
              defaultFirstOption
            >
              <el-option
                v-for="item in allCities"
                :label="item.city"
                :value="item.adcode"
                :key="item.adcode"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="网约钱包支付签约状态" prop="walletWithholdState">
            <el-select
              v-model="params.walletWithholdState"
              clearable
              placeholder="请选择网约钱包支付签约状态"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in walletState"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="支付宝支付签约状态"
            prop="personalWithholdState"
          >
            <el-select
              v-model="params.personalWithholdState"
              clearable
              placeholder="请选择支付宝支付签约状态"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in alipayWithholdState"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
          <!--租赁模式  -->
          <el-form-item label="租赁类别" prop="rentCategory">
            <el-select
              v-model="params.rentCategory"
              clearable
              placeholder="请选择租赁类别"
            >
              <el-option label="全部" value="" />
              <el-option
                v-for="item in categoryList"
                :label="item.name"
                :value="item.code"
                :key="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="订单创建时间" prop="TheOrderStart">
            <el-date-picker
              v-model="params.TheOrderStart"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="starttime"
              clearable
              :default-time="['00:00:00', '23:59:59']"
            />
          </el-form-item>
          <el-form-item label="租赁方案名称" prop="planId">
            <el-select
              v-model="params.planId"
              clearable
              filterable
              placeholder="请选择租赁方案"
            >
              <el-option
                v-for="item in planList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="合同备案状态" prop="contractFilingState">
            <el-select
              v-model="params.contractFilingState"
              clearable
              filterable
              placeholder="请选择租赁方案"
            >
              <el-option
                v-for="(item,index) in contractFilingStateList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="所属部门" prop="deptIdList">
            <DeptSelect ref="deptSelectRef" v-model="params.deptIdList" multiple :isAll="false" />
          </el-form-item>
          <!-- 按钮区域，slot方式，各个按钮要单独用item包裹-->
          <template slot="moreBtn">
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                class="whole_contract_btn"
                @click="handleSearch"
                :loading="BLMloading"
              >
                查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                size="small"
                class="whole_contract_btn"
                @click="goReset"
                >重置
              </el-button>
            </el-form-item>
            <el-form-item>
              <div class="whole_contract_ex">
                <PublicExport
                  v-if="judgePermission('workbench_rent_order_export')"
                  exportTitle="个人租赁订单导出"
                  exportTemplate="Tenant"
                  :getSearchData="getCollect"
                  templateCode="vehicle-workbench-rent-order"
                  :getSearchCondition="getSearchCondition"
                />
              </div>
            </el-form-item>
          </template>
        </QS-search>
      </el-form>
    </div>
    <!-- 开始------------------>
    <div class="leasecontract_signing">
      <el-button
        type="primary"
        size="small"
        class="whole_contract_btn"
        v-if="judgePermission('workbench_rent_order_add')"
        @click="addSigning"
        >
        新增签约
      </el-button>
    </div>
    <!-- 结束------------------>
    <QSCommonTable
        :loading="BLMloading"
        :data="tableData"
        :columns="colList"
        :pagination="pagination"
        :height="tableHeight"
        @change="handleTableChange"
    />

    <dialogWrap
      v-model="msgDialogVisible"
      :before-close="closeMsgDialogVisible"
      title="提示"
      :width="'524px'"
      >
      <div>未开通网约钱包支付功能</div>
      <template slot="footer">
        <el-button
          type="primary"
          size="small"
          @click="closeMsgDialogVisible"
          >
          确定
        </el-button>
      </template>
    </dialogWrap>

    <!-- 取消订单弹框 -->
    <el-dialog
      title="取消原因"
      :visible.sync="cancelDialogVisible"
      width="400px"
      >
      <div class="radioGroup">
        <el-radio-group v-model="closeReason">
          <el-radio label="账户资金不足">账户资金不足</el-radio>
          <el-radio label="签约失败">签约失败</el-radio>
          <el-radio label="交付信息有误">交付信息有误</el-radio>
          <el-radio label="不想租车了">不想租车了</el-radio>
          <el-radio label="信息填写错误">信息填写错误</el-radio>
          <el-radio label="其他" value="其他">其他</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="cancelLoading" @click="handleConfirmCancel">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 签约支付宝支付 -->
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <signAlipayWithholdDrawer ref="signAlipayWithholdDrawerRef" @update="getTableData" />

    <!-- 发起支付宝支付 -->
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <alipayWithholdDialogNew ref="alipayWithholdDialogNewRef" />

    <!-- 签约网约钱包支付抽屉 -->
    <SignWithholdDrawer ref="signWithholdDrawerRef" @complete="getTableData" />

    <!-- 解约支付宝、网约代扣 -->
    <UnBindWithhold ref="unBindWithholdRef" @update="getTableData" />

    <!-- 一键换车 -->
    <OneKeyCarChange ref="oneKeyChangeCarRef" @updateList="getTableData" />

  </div>
</template>
<script>
import {
  cancelOrder,
  getLeasingSchemeConfigListAll,
  stockLogFindLastOne,
} from '@/api/domain/cars.js'
import { getAllEmployeeList } from '@/api/carManage/index.js'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { checkBeforeChangeCar } from '@/api/domain/finance.js'
import {
  FuzzySearch,
  getPersonalOrders,
  SureGiveup,
} from '@/api/purchaseAndSaleAPI'
import { cancelWalletWithhold } from '@/api/withhold.js'

import selectOptionDict from '@/store/dict/selectOptionDict'
import listConfig from '../config/index'

import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import UnBindWithhold from '@/pages/orders/components/UnBindWithhold.vue'
import alipayWithholdDialogNew from '@/pages/orders/components/alipayWithholdDialogNew.vue'
import { UNBIND_TITLE, WITHHOLD_TYPE } from '@/pages/orders/components/const'
import signAlipayWithholdDrawer from '@/pages/orders/components/paymentChannels/aliPay/index.vue'
import SignWithholdDrawer from '@/pages/orders/components/paymentChannels/driverIncomes/index.vue'
import { check } from '@/pages/orders/components/withholdCheck.js'
import OneKeyCarChange from '@/pages/orders/personalOrder/components/oneKeyCarChange'
import { generateExportCondition } from '@/utils/exportUtils.js'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'PersonalOrderList',
  components: {
    signAlipayWithholdDrawer,
    alipayWithholdDialogNew,
    CustomerNameOptionItem,
    SignWithholdDrawer,
    UnBindWithhold,
    OneKeyCarChange,
  },
  props: {
    levelTab: {
      type: [Number, String],
      default: '0',
    },
    tabNo: {
      type: [Number, String],
      default: 0,
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleSummary: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    const { allTabList, stayProcessTabList, accountingTabList } = listConfig.call(this)
    return {
      /* eslint-disable-next-line vue/no-unused-properties */
      allTabList,
      stayProcessTabList,
      accountingTabList,
      params: {
        rentCategory: '', // 租赁模式
        bizType: 10, // 常量
        id: '', // 合同ID
        carId: '', // 车牌号ID
        modelId: '', // 车型
        customerId: '', // 客户名称ID
        closeType: '',
        TheOrderStart: [], // 创建订单开始时间
        relatedType: '', // 关联订单原因
        contractState: '', // 签署合同状态
        tabNo: 0,
        walletWithholdState: '', // 网约钱包支付状态
        personalWithholdState: '', // 支付宝签约代扣状态
        providerId: '', // 车源服务商
        source: '', // 下单方式
        bookTime: [], // 预约到店时间
        planId: '', // 租赁方案名称
        deptIdList: [], // 部门
        adcode: '', // 运营城市
        driverManagerId: '', // 所属司管ID
      },
      params_rules: {
        contractId: [{ max: 18, message: '最多18个', trigger: 'blur' }],
      },
      options: [],
      carOptions: [],
      dmOptions: [], // 司管列表
      planList: [], // 租赁方案list
      loading: false,
      dmLoading: false,
      // 表格总数据
      total: 0,
      // 表格请求的总数据
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      // 标签类型 1全部合同/2已签约合同/3待签约合同/4已作废合同/5已解约合同/630天内到期/7已过期合同
      state: 1,
      BLMloading: false,
      msgDialogVisible: false,
      cancelDialogVisible: false, // 订单取消弹窗flag
      cancelLoading: false,
      closeReason: null, // 订单取消原因
      closeOrderId: null, // 取消的订单号
      tableHeight: 0, // 默认最小高度
      carConditionList: [], // 车牌号列表
      customerConditionList: [], // 客户名称列表
      dmConditionList: [], // 司管列表
    }
  },
  watch: {
    'params.carId': {
      handler() {
        this.carConditionList = this.carOptions
      },
    },
    'params.customerId': {
      handler() {
        this.customerConditionList = this.options
      },
    },
    'params.driverManagerId': {
      handler() {
        this.dmConditionList = this.dmOptions
      },
    },
  },
  computed: {
    ...mapState({
      // 租赁模式
      categoryList: (state) => {
        const list = [...state.global.categoryList]
        return list
      },
    }),
    ...mapGetters(['allCities']),
    pagination() {
      return {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        total: this.total,
      }
    },
    colList() {
      const { headData } = listConfig.call(this)
      return headData.filter((col) => {
        // 下单手机号列仅在待绑车Tab(tabNo=5)下展示
        if (col.name === 'customerSafetyTel') {
          return String(this.tabNo) === '5'
        }
        return true
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    isWhetherList() {
      return this.dictParseList(selectOptionDict.isWhetherList)
    },
    // 线上代扣协议确认状态
    // eslint-disable-next-line vue/no-unused-properties
    confirmStateList() {
      return this.dictParseList(selectOptionDict.confirmStateList)
    },
    // 租金收款方式
    // eslint-disable-next-line vue/no-unused-properties
    payMethodList() {
      return this.dictParseList(selectOptionDict.payMethods)
    },
    walletState() {
      return this.dictParseList(selectOptionDict.walletWithholdState)
    },
    alipayWithholdState() {
      return this.dictParseList(selectOptionDict.alipayWithholdStateNew)
    },
    // eslint-disable-next-line vue/no-unused-properties
    alipayState() {
      return this.dictParseList(selectOptionDict.alipayWithholdState)
    },
    contractFilingStateList() {
      return this.dictParseList(selectOptionDict.contractFilingStateList)
    },
  },
  mounted() {
    this.getRouteQuery()
    this.getPlanList() // 获取租赁方案list
    this.loadAllDriverManagers() // 加载所有司管
    const planId = this.$route?.query?.planId
    // getPlanList 中有getTableData，防止重复请求
    !planId && this.getTableData()
    // 获取租赁模式
    this.$store.dispatch('getPaymentMethods', { type: 'rentCategory' })
    // 动态计算表格宽度
    this.calcTableHeight()
    window.addEventListener('resize', () => {
      this.calcTableHeight()
    })
  },
  activated() {
    this.calcTableHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.calcTableHeight()
    })
  },
  methods: {
    async getPlanList() {
      // orderType(类型) - 1:个人; 2:企业;
      const res = await getLeasingSchemeConfigListAll({ orderType: 1 })
      const data = res?.data || []
      const customerOption = {
        name: '自定义',
        id: 0,
      }
      data.unshift(customerOption)
      this.planList = data
      const planId = this.$route?.query?.planId
      if (planId) {
        this.params.planId = Number(planId)
        this.getTableData()
      }
    },
    // 重置--清空表单项
    goReset(flag) {
      this.pageSize = 10
      this.pageNum = 1
      // 使表单内容重新赋值为空字符串
      this.$refs.from_params?.resetFields()
      this.starttime()
      this.bookTimeChange()
      this.getTableData(flag)
    },
    // 请求数据table 获取列表车辆
    async getTableData() {
      //  如果是页面最外层的tab切换，使用缓存数据（避免页面多次请求）
      this.BLMloading = true
      this.$emit('handleSummary')
      try {
        const { code, data } = await getPersonalOrders({
          ...this.getCollect(),
        })
        this.BLMloading = false
        if (code === 1) {
          this.tableData = data.items || []
          this.total = data.totalNum || 0
        }
      } catch (error) {
        this.BLMloading = false
      }
    },
    // 新增签约按钮点击事件
    addSigning() {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
      })
    },
    starttime(data) {
      this.params.createTimeStart = (data && data[0]) || ''
      this.params.createTimeEnd = (data && data[1]) || ''
    },

    bookTimeChange(data) {
      this.params.bookTimeStart = (data && data[0]) || ''
      this.params.bookTimeEnd = (data && data[1]) || ''
    },

    // 收集上传的数据
    getCollect() {
      return {
        ...this.params,
        tabNo: this.tabNo,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
    },
    // 加载所有司管
    async loadAllDriverManagers() {
      this.dmLoading = true
      try {
        const { code, data } = await getAllEmployeeList({ includeDisabled: 'YES' })
        if (code === 1) {
          this.dmOptions = data
          this.dmConditionList = data
        }
      } finally {
        this.dmLoading = false
      }
    },
    // 客户名称远程搜索 input事件 ------开始
    async remoteMethod(query, str) {
      if (str === 'customerId') {
        if (query.length >= 1) {
          // 开启远程搜索
          this.loading = true
          try {
            const { code, data } = await searchByCustomerNameSensitive({
              customerState: 1,
              customerType: 1,
              customerName: query,
            })
            if (code === 1) {
              // 关闭远程搜索
              this.loading = false
              this.options = data
            }
          } catch (error) {
            // 关闭远程搜索
            this.loading = false
          }
        } else {
          this.options = []
        }
      } else {
        // 车牌号
        if (query.length >= 4) {
          // 开启远程搜索
          this.loading = true
          const { code, data } = await FuzzySearch({
            state: 1,
            plateNo: query,
          })
          if (code === 1) {
            // 关闭远程搜索
            this.loading = false
            this.carOptions = data
          }
          return
        }
        this.carOptions = []
      }
    },
    // 关闭提示弹框
    closeMsgDialogVisible() {
      this.msgDialogVisible = false
    },
    // eslint-disable-next-line vue/no-unused-properties
    giveupTheCar({ id }) {
      this.$confirm('确定要放弃退车吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async () => {
        const { code } = await SureGiveup({
          orderId: id,
        })
        if (code === 1) {
          this.$message({
            message: '放弃退车成功',
            type: 'success',
          })
          this.getTableData()
        }
      }).catch(() => null)
    },
    // 获取路由参数
    getRouteQuery() {
      // 历史逻辑
      const { tagType, relationReason, attributeId, carId, plateNo, orderId } = this.$route.query
      if (plateNo) {
        this.remoteMethod(plateNo, 'carId')
        this.params.carId = Number(carId)
      }
      // attributeId 待办任务跳转
      this.params.id = Number(attributeId) || ''
      if (tagType) {
        this.state = tagType
      }
      if (relationReason) {
        this.params.closeType = Number(relationReason)
      }
      if (orderId) {
        this.params.id = orderId
      }
    },
    handleTableChange({ pagination }) {
      this.pageSize = pagination.pageSize
      this.pageNum = pagination.pageNum
      // pageSize 和 pageNum 更新，把tabList中的缓存数据也进行更新
      this.getTableData()
    },
    // 展示开启网约钱包支付
    // eslint-disable-next-line vue/no-unused-properties
    async showOpenWalletWithhold(row) {
      const { id: orderId, rentCategory } = row
      check(orderId, WITHHOLD_TYPE.WALLET).then(() => {
        this.$refs.signWithholdDrawerRef.openDrawer({ orderId, rentCategory })
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    showOpenAlipayWithhold(row) {
      check(row.id, WITHHOLD_TYPE.ALIPAY).then(() => {
        this.$refs.signAlipayWithholdDrawerRef.openDrawer(row)
      })
    },
    // 展开解约网络钱包代扣
    // eslint-disable-next-line vue/no-unused-properties
    showRescindAlipayWithhold(row, type) {
      this.$refs.unBindWithholdRef.open({
        title: UNBIND_TITLE[type],
        orderId: row.id,
        type, // 1:网约钱包支付 2:支付宝支付
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    async showOneKeyChangeCar(row, type) {
      if (type === 'selectNewCar') {
        const { code } = await checkBeforeChangeCar({
          orderId: row.id,
        })
        if (code === 1) {
          this.$refs.oneKeyChangeCarRef.open(row, type)
        }
      } else {
        this.$refs.oneKeyChangeCarRef.open(row, type)
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    showRescindWalletWithhold(row) {
      this.$confirm('解除后将不再从网约钱包支付自动扣款，是否确认解除', '解除网约钱包支付', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { code } = await cancelWalletWithhold({
          orderId: row.id,
        })
        if (code === 1) {
          this.$message.success('解除网约钱包支付成功')
        }
      }).catch(() => null)
    },
    // 获取出入库记录
    // eslint-disable-next-line vue/no-unused-properties
    outInBankPop(id, type, relatedType, row) {
      // 新
      if (!relatedType) {
        const query = { orderId: row.id }
        this.$router.push({
          path: '/car_to_lease/forRentSignContract/personalSignContract',
          query,
        })
        return
      }
      this.returnCar(id, type, row)
    },
    // 退车
    returnCar(id, type, row) {
      stockLogFindLastOne({
        carId: id,
        type,
        orderId: row.id,
        sourceType: 1,
        sourceId: row.id,
      }).then((res) => {
        const { data } = res
        this.$router.push({
          path: '/vehicle/outInStorage/edit',
          query: {
            carId: id,
            type,
            stockId: data.id,
            from: 'lease', // 为了让出入库页面back
          },
        })
      })
    },
    // 去订单确认页面
    // eslint-disable-next-line vue/no-unused-properties
    toOrderConfirmPage(row) {
      const { relatedType, id, relatedOrderId } = row

      if (relatedType) {
        // 订单续约跳转到新场景化页面，其他的跳老详情页
        return relatedType === 4 ?
          this.toNewOrderRenewalPage(
            { orderId: id, oldOrderId: relatedOrderId },
          ) :
          this.toOrderDetailPage({ id, confirm: 1 })
      }
      // 新
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
        query: { orderId: id },
      })
    },
    // 查看财务进度 =》收付款信息
    // eslint-disable-next-line vue/no-unused-properties
    toReceiptandpayment(row) {
      // 新
      const query = { orderId: row.id }
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/personalSignContract',
        query,
      })
    },
    // 点击订单关闭
    // eslint-disable-next-line vue/no-unused-properties
    closeTheCar(row) {
      const queryObj = { orderId: row.id, scene: this.$route.query.scene }
      const queryStr = JSON.stringify(queryObj)
      this.$router.push({
        name: 'return_lease_start',
        query: {
          query: queryStr,
          operateState: 'closeCar',
        },
      })
    },
    // 去客户还车页面
    // eslint-disable-next-line vue/no-unused-properties
    toReturnCarPage(row) {
      const queryObj = { orderId: row.id, scene: this.$route.query.scene }
      const queryStr = JSON.stringify(queryObj)
      this.$router.push({
        name: 'return_lease_start',
        query: {
          query: queryStr,
        },
      })
    },
    // 去绑车
    // eslint-disable-next-line vue/no-unused-properties
    handleToBindCar(row) {
      this.$router.push({
        name: 'for_rent_sign_contract_rent_order_create',
        query: {
          orderId: row.id,
          source: 2,
        },
      })
    },
    // 取消订单
    // eslint-disable-next-line vue/no-unused-properties
    handleCancelOrder(row) {
      this.closeOrderId = row.id
      this.closeReason = ''
      this.cancelLoading = false
      this.cancelDialogVisible = true
    },
    // 确认取消订单
    async handleConfirmCancel() {
      if (this.cancelLoading) return
      if (!this.closeReason) {
        this.$message.error('请选择取消原因')
        return
      }
      this.cancelLoading = true
      try {
        const { code } = await cancelOrder({
          orderId: this.closeOrderId,
          closeReason: this.closeReason,
        })
        this.closeOrderId = null
        if (code !== 1) {
          this.cancelLoading = false
          return
        }
        this.cancelDialogVisible = false
        this.$message.success('订单取消成功！')
        // 刷新数据
        setTimeout(() => {
          this.getTableData()
          this.$emit('handleSummary')
        }, 1500)
      } catch {
        this.cancelLoading = false
      }
    },
    // 跳转到场景化个人订单续约
    toNewOrderRenewalPage(query) {
      this.$router.push({
        path: '/underLease/orderRenewal/personalAdd',
        query,
      })
    },
    // 去租赁订单详情页面公用跳转方法
    // 公用路径，传递参数
    toOrderDetailPage(query, hash) {
      const routeUrl = this.$router.resolve({
        path: '/workbench/rentOrder/detail',
        query,
      })
      this.$router.push({
        path: routeUrl.href,
        query: {
          ...query,
          orderType: 'personal',
        },
        hash,
      })
    },
    calcTableHeight() {
      this.$nextTick(() => {
        const offset = 420 // 除去表格其他元素总高度
        let computedHeight = window.innerHeight - this.$refs?.tableWrapper?.offsetTop - offset

        // 有缓存时快速切换高度会计算错误， 使用tableWrapper高度兜底
        if ((window.innerHeight - this.$refs?.tableWrapper?.offsetTop) < offset) {
          computedHeight = this.$refs?.tableWrapper?.offsetTop
        }

        // 如果视窗高度大于700，则使用视窗高度减固定高度(因为此时计算可能存在问题,直接做减法即可)
        if (window.innerHeight > 700) {
          this.tableHeight = window.innerHeight - 420
        } else {
          this.tableHeight = computedHeight < 248 ? 248 : computedHeight
        }
      })
    },
    getSearchCondition() {
      const formConfig = [{
        el: 'select',
        itemConfig: {
          label: '车牌号',
          prop: 'carId',
        },
        elConfig: {
          options: {
            list: this.carConditionList,
            value: 'id',
            label: 'plateNo',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '司机姓名',
          prop: 'customerId',
        },
        elConfig: {
          options: {
            list: this.customerConditionList,
            value: 'id',
            label: 'customerName',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '所属司管',
          prop: 'driverManagerId',
        },
        elConfig: {
          options: {
            list: this.dmConditionList,
            value: 'id',
            label: 'userName',
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '订单ID',
          prop: 'id',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '运营城市',
          prop: 'adcode',
        },
        elConfig: {
          options: {
            list: this.allCities,
            value: 'adcode',
            label: 'city',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '网约钱包支付签约状态',
          prop: 'walletWithholdState',
        },
        elConfig: {
          options: {
            list: this.walletState,
            value: 'value',
            label: 'label',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '支付宝支付签约状态',
          prop: 'personalWithholdState',
        },
        elConfig: {
          options: {
            list: this.alipayWithholdState,
            value: 'value',
            label: 'label',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '租赁类别',
          prop: 'rentCategory',
        },
        elConfig: {
          options: {
            list: this.categoryList,
            value: 'code',
            label: 'name',
          },
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '订单创建时间',
          prop: 'TheOrderStart',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '租赁方案名称',
          prop: 'planId',
        },
        elConfig: {
          options: {
            list: this.planList,
            value: 'id',
            label: 'name',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '所属部门',
          prop: 'deptIdList',
        },
        elConfig: {
          options: {
            list: this.$refs.deptSelectRef.flatOptions(),
            value: 'id',
            label: 'name',
          },
        },
      }]
      const condition = formConfig.map((item) => {
        const { el, itemConfig: { label, prop: key } } = item
        const val = this.getCollect()[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      // Tab需要放入导出的查询条件中
      condition.push({
        label: '订单类型',
        matchValue: this.allTabList.find((item) => String(item.state) === this.levelTab)?.name,
      })
      // 待履约（10）、退车核算（3）有二级Tab
      if (['3', '10'].includes(this.levelTab)) {
        condition.push({
          label: '订单状态',
          matchValue: [...this.stayProcessTabList, ...this.accountingTabList].find((item) => String(item.state) === this.tabNo)?.name,
        })
      }
      return condition
    },
    handleSearch() {
      // 直接点击搜索时直接到第一页
      this.pageNum = 1
      this.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.radioGroup {
  padding-left: 20px;
  .el-radio-group {
    display: display;
    .el-radio {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
